import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import { push } from 'react-router-redux';
import { Checkbox } from 'rmwc';
import * as styles from '../styles';
import { imageUrl } from '../utilities/requests';
import Tree from '../components/tree';
import DatePicker from '../date-picker/date_picker';
import { setSelectedItems } from '../components/tree/actions';
import { addReducer, clearReducers } from '../utilities/dynamic_reducer';
import { request } from '../containers/actions';

//@Radium
export default class Edit extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        data: {},
        schema: {},
        errors: {},
        mass: false,
        exclude: [],
        openGenderBox: false
    };

    componentDidMount() {
        if (this.props.resource && this.props.id)
            this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (
            (prevProps.resource !== this.props.resource || (
                prevProps.id !== this.props.id && (!this.state.data || this.state.data.id !== this.props.id)
            )) &&
            this.props.id
        )
            this.fetch.bind(this)();
    }

    async save() {
        debugger;
        const url = this.props.id === 'add' || this.state.mass
            ? `/${this.props.resource}/`
            : `/${this.props.resource}/${this.props.id}/`;
        try {
            let payload = _.pickBy(_.mapValues(
                this.state.schema,
                (fieldDescription, field) => {
                    let value = undefined;
                    if (_.includes(_.keys(this.props.hiddenDefaults), field))
                        value = this.props.hiddenDefaults[field];
                    else if (fieldDescription.type === 'choice') {
                        value = this.props.store.getIn(['states', field, 'selected']).keySeq().first();
                    }
                    else if (fieldDescription.type === 'image') {
                        value = this.state.data[field] ? this.state.data[field].file : undefined;
                    }
                    else if (fieldDescription.resource) {
                        if (fieldDescription.resource === 'subject')
                            value = this.props.store.getIn(['states', field + '-subject', 'selected']).keySeq().toArray();
                        else if (fieldDescription.resource === 'grade' && this.props.resource !== 'marker' && this.props.resource !== 'manager')
                            value = this.props.store.getIn(['states', field + '-grade', 'selected']).keySeq().toArray();
                        else if (fieldDescription.resource === 'question-type')
                            value = this.props.store.getIn(['states', field + '-question-type', 'selected']).keySeq().toArray();
                        else if (fieldDescription.resource === 'class')
                            value = this.props.store.getIn(['states', field + '-class', 'selected']).keySeq().toArray();
                        else if (fieldDescription.resource === 'school')
                            value = this.props.store.getIn(['states', field + '-school', 'selected']).keySeq().toArray();
                        else if (fieldDescription.resource === 'city')
                            value = this.props.store.getIn(['states', field + '-city', 'selected']).keySeq().toArray();
                        else
                            value = this.props.store.getIn(['states', field, 'selected']).keySeq().toArray();
                        if (fieldDescription.multiple) {
                            if (fieldDescription.child.type === 'nested object' && value)
                                value = _.map(value, id => ({ id }));
                        }
                        else {
                            value = value[0];
                            if (fieldDescription.type === 'nested object' && value)
                                value = { id: value };
                        }
                    }
                    else {
                        value = this.state.data[field];
                        if (value === '')
                            value = null;
                    }
                    if (
                        fieldDescription.read_only ||
                        value instanceof Array && value.length === 0
                        //value instanceof Array is detect value is array or not
                    )
                        value = undefined;
                    if (value === null)
                        value = '\0';
                    return value;
                }
            ), value => value !== undefined);
            if (this.state.mass) {
                payload = _.map(this.props.id.split(','), id => ({ ...payload, id }));
            }
            debugger;
            const data = await this.context.store.dispatch(request({
                path: url,
                body: window.toFormData({ ...payload, gender: this.state.data.gender ?? '\0' }),
                method: this.props.id === 'add' ? 'POST' : 'PATCH',
            }));
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            )
            if (!this.state.mass) {
                if (this.props.close)
                    this.props.close(data.id);
                else
                    this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + `/${data.id}/`));
                this.setState({ data });
            }
            this.setState({ saved: true });
            setTimeout(() => this.setState({ saved: undefined }), 1000);
        }
        catch (exception) {
            console.log("error",exception)
            this.setState({
                errors: exception instanceof Array ? exception[0] : exception,
                saved: false,
            });
            setTimeout(() => this.setState({ saved: undefined }), 1000);
            return false;
        }
        return true;
    }

    async fetch() {
        this.setState({ errors: {}, data: undefined, schema: undefined });
        this.context.store.dispatch(clearReducers(this.props.store.get('elementId')));
        const mass = _.includes(this.props.id, ',');
        const url = this.props.id === 'add'
            ? `/${this.props.resource}/`
            : `/${this.props.resource}/${String(this.props.id).split(',')[0]}/`;
        const data = mass
            ? {}
            : this.props.id === 'add' ? {} : await this.context.store.dispatch(request(url));
        const schema = _.pickBy((await this.context.store.dispatch(
            request({ path: url, method: 'OPTIONS' }),
        )).actions[this.props.id === 'add' ? 'POST' : 'PUT'], (__, field) => !_.includes(this.props.exclude, field));
        await Promise.all(_.map(schema, async (fieldDescription, field) => {
            if (fieldDescription.type === 'choice') {
                // test are here
                const elementId = window.uuidv4();
                const choices = _.mapValues(
                    _.mapKeys(fieldDescription.choices, choice => choice.value),
                    choice => ({ id: choice.value, label: choice.display_name }),
                );
                await this.context.store.dispatch([
                    addReducer(field, 'tree', {
                        elementId,
                        staticItems: choices,
                    }, this.props.store.get('elementId')),
                    setSelectedItems(
                        data[field] ? [data[field]] : [],
                        elementId,
                        this.props.store.getIn(['states', field, 'elementId']),
                    ),
                ]);

            }
            else if (fieldDescription.resource) {
                if (fieldDescription.resource === 'subject') {
                    await this.context.store.dispatch([
                        addReducer(field + '-material', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-subject', 'tree', this.props.store.get('elementId')),
                    ]);
                    await window.wait();
                    this.context.store.dispatch([
                        setSelectedItems(
                            data[field] && data[field].parent_material_id
                                ? [data[field].parent_material_id]
                                : [],
                            'material',
                            this.props.store.getIn(['states', field + '-material', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].id ? [data[field].id] : [],
                            'subject',
                            this.props.store.getIn(['states', field + '-subject', 'elementId']),
                        ),
                    ]);
                }
                else if (fieldDescription.resource === 'grade' && this.props.resource !== 'marker' && this.props.resource !== 'manager') {
                    await this.context.store.dispatch([
                        addReducer(field + '-level', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-grade', 'tree', this.props.store.get('elementId')),
                    ]);
                    await window.wait();
                    this.context.store.dispatch([
                        setSelectedItems(
                            data[field] && data[field].level && data[field].level.id
                                ? [data[field].level.id]
                                : [],
                            'level',
                            this.props.store.getIn(['states', field + '-level', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].id ? [data[field].id] : [],
                            'grade',
                            this.props.store.getIn(['states', field + '-grade', 'elementId']),
                        ),
                    ]);
                }
                else if (fieldDescription.resource === 'question-type') {
                    await this.context.store.dispatch([
                        addReducer(field + '-material', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-question-type', 'tree', this.props.store.get('elementId')),
                    ]);
                    await window.wait();
                    this.context.store.dispatch([
                        setSelectedItems(
                            data[field] && data[field].parent_material_id
                                ? [data[field].parent_material_id]
                                : [],
                            'material',
                            this.props.store.getIn(['states', field + '-material', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].id ? [data[field].id] : [],
                            'question-type',
                            this.props.store.getIn(['states', field + '-question-type', 'elementId']),
                        ),
                    ]);
                }
                else if (fieldDescription.resource === 'class') {
                    await this.context.store.dispatch([
                        addReducer(field + '-region', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-city', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-school', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-class', 'tree', this.props.store.get('elementId')),
                    ]);
                    await window.wait();
                    this.context.store.dispatch([
                        setSelectedItems(
                            data[field] && data[field].school && data[field].school.city && data[field].school.city.region
                                ? [data[field].school.city.region]
                                : [],
                            'region',
                            this.props.store.getIn(['states', field + '-region', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].school && data[field].school.city ? [data[field].school.city.id] : [],
                            'city',
                            this.props.store.getIn(['states', field + '-city', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].school ? [data[field].school.id] : [],
                            'school',
                            this.props.store.getIn(['states', field + '-school', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].id ? [data[field].id] : [],
                            'class',
                            this.props.store.getIn(['states', field + '-class', 'elementId']),
                        ),
                    ]);
                }
                else if (fieldDescription.resource === 'school') {
                    await this.context.store.dispatch([
                        addReducer(field + '-region', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-city', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-school', 'tree', this.props.store.get('elementId')),
                    ]);

                    await window.wait();
                    this.context.store.dispatch([
                        setSelectedItems(
                            data[field] && data[field].city && data[field].city.region
                                ? [data[field].city.region]
                                : [],
                            'region',
                            this.props.store.getIn(['states', field + '-region', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].city ? [data[field].city.id] : [],
                            'city',
                            this.props.store.getIn(['states', field + '-city', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].id ? [data[field].id] : [],
                            'school',
                            this.props.store.getIn(['states', field + '-school', 'elementId']),
                        ),
                    ]);
                }
                else if (fieldDescription.resource === 'city') {
                    await this.context.store.dispatch([
                        addReducer(field + '-region', 'tree', this.props.store.get('elementId')),
                        addReducer(field + '-city', 'tree', this.props.store.get('elementId')),
                    ]);
                    await window.wait();
                    this.context.store.dispatch([
                        setSelectedItems(
                            data[field] && data[field].region ? [data[field].region] : [],
                            'region',
                            this.props.store.getIn(['states', field + '-region', 'elementId']),
                        ),
                        setSelectedItems(
                            data[field] && data[field].id ? [data[field].id] : [],
                            'city',
                            this.props.store.getIn(['states', field + '-city', 'elementId']),
                        ),
                    ]);
                }
                else {
                    await this.context.store.dispatch(addReducer(field, 'tree', this.props.store.get('elementId')));
                    await window.wait();
                    if (fieldDescription.multiple) {
                        this.context.store.dispatch(setSelectedItems(
                            fieldDescription.child.type === 'nested object'
                                ? data[field] ? _.map(data[field], item => item.id) : []
                                : data[field] ? data[field] : [],
                            fieldDescription.resource,
                            this.props.store.getIn(['states', field, 'elementId']),
                        ));
                    }
                    else {
                        this.context.store.dispatch(setSelectedItems(
                            fieldDescription.type === 'nested object'
                                ? data[field] && data[field].id ? [data[field].id] : []
                                : data[field] ? [data[field]] : [],
                            fieldDescription.resource,
                            this.props.store.getIn(['states', field, 'elementId']),
                        ));
                    }
                }
            }
        }));
        this.setState({
            data,
            schema: _.mapValues(
                schema,
                field => ({
                    ...field,
                    partial_regex_validator: field.regex_validator
                        ? new RegExp(field.regex_validator).toPartialMatchRegex()
                        : undefined,
                    regex_validator: field.regex_validator
                        ? new RegExp(field.regex_validator)
                        : undefined,
                }),
            ),
            mass,
        });
    }

    render() {
        if (!this.state.data || !this.state.schema)
            return null;
        if (
            _.some(this.state.schema, fieldDescription => fieldDescription.resource || fieldDescription.type === 'choice') &&
            this.props.store.get('states').size === 0
        )
            return null;
        return <div style={{ width: '100%', fontSize: '.9em', paddingBottom: '1em', display: 'inline-block' }}>
            <input
                type='file'
                accept='image/*'
                ref='imageSelector'
                style={{ display: 'none' }}
                onClick={() => {
                    this.refs.imageSelector.value = '';
                }}
                onChange={async () => {
                    const field = this.refs.imageSelector.dataset.field;
                    const file = this.refs.imageSelector.files[0];
                    const data = await window.readFile(file);
                    this.setState(update(this.state, { data: { [field]: { $set: { data, file } } } }));
                }}
            />
            {_.map(
                this.state.schema,
                (fieldDescription, field) =>
                    [
                        <div
                            key={field + '-container'}
                            style={{
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                width: 'calc(50% - 1em)',
                                marginBottom: '1em',
                                position: 'relative',
                            }}>
                            {/* error filed for any part  */}
                            {_.map(
                                this.state.errors[field],
                                (error, index) => <div
                                    key={index}
                                    style={{ marginRight: '1.5em', color: styles.alertColor }}>
                                    * {error}
                                </div>,
                            )}
                            {fieldDescription.type === 'boolean' || _.includes(_.keys(this.props.hiddenDefaults), field)
                                ? null
                                // return title of any part like gender , name, city , level,...
                                : <div
                                    style={{
                                        // display: `${fieldDescription.label !== "جنسیت" ? "inline-block" : (this.props.resource === "student" || this.props.resource === "school") ? "inline-block" : "none"}`,
                                        display: "inline-block",
                                        width: '15em',
                                        fontSize: '.9em',
                                        fontWeight: fieldDescription.required ? '700' : '500',
                                        color: fieldDescription.required ? '#3a3a3a' : '#6a6a6a',
                                        verticalAlign: 'top',
                                    }}>
                                    {window.gettext(fieldDescription.label)}:

                                </div>
                            }
                            {(() => {
                                const readonly = fieldDescription.read_only ||
                                    (this.state.mass && fieldDescription.unique);
                                if (_.includes(_.keys(this.props.hiddenDefaults), field))
                                    return null;
                                else if (fieldDescription.type === 'boolean') {
                                    return <Checkbox
                                        key={field}
                                        checked={this.state.data[field] || false}
                                        onChange={({ target: { checked } }) => {
                                            if (readonly)
                                                return;
                                            this.setState(update(this.state, { data: { [field]: { $set: checked } } }));
                                        }}>
                                        {window.gettext(fieldDescription.label)}
                                    </Checkbox>;
                                }
                                else if (fieldDescription.type === 'integer') {
                                    if (readonly)
                                        return this.state.data[field] || '';
                                    else {
                                        const valid = (this.state.data[field] || '') === ''
                                            ? (this.state.mass || !fieldDescription.required || fieldDescription.write_only)
                                            : !(
                                                this.state.errors[field] ||
                                                fieldDescription.regex_validator &&
                                                !(this.state.data[field] || '').match(
                                                    Radium.getState(this.state, field, ':focus')
                                                        ? fieldDescription.partial_regex_validator
                                                        : fieldDescription.regex_validator
                                                ) ||
                                                fieldDescription.min_length &&
                                                (this.state.data[field] || '').length < fieldDescription.min_length ||
                                                fieldDescription.max_length &&
                                                (this.state.data[field] || '').length > fieldDescription.max_length
                                            );
                                        const element = <input
                                            key={field}
                                            style={{
                                                ...styles.input,
                                                border: valid
                                                    ? styles.field.border
                                                    : `.0625em solid ${styles.alertColor}`,
                                                backgroundColor: valid
                                                    ? styles.input.backgroundColor
                                                    : styles.alertBackColor,
                                            }}
                                            value={(this.state.data[field] || '').persian()}
                                            onChange={({ target: { value } }) => {
                                                value = value.english();
                                                if (fieldDescription.partial_regex_validator) {
                                                    if (
                                                        value.length > 0 &&
                                                        !value.match(fieldDescription.partial_regex_validator)
                                                    )
                                                        return;
                                                }
                                                else {
                                                    if (isNaN(Number(value)) && value.length > 0)
                                                        return;
                                                    if (value.length > fieldDescription.max_length)
                                                        return;
                                                    if (Number.parseInt(value) < 0)
                                                        return;
                                                    value = isNaN(Number.parseInt(value)) ? '' : value;
                                                }
                                                this.setState(update(this.state, { data: { [field]: { $set: value } } }));
                                            }}
                                        />;
                                        return element;
                                    }
                                }
                                else if (fieldDescription.type === 'float') {
                                    if (readonly)
                                        return this.state.data[field] || '';
                                    else {
                                        const valid = (this.state.data[field] || '') === ''
                                            ? (this.state.mass || !fieldDescription.required || fieldDescription.write_only)
                                            : !(
                                                this.state.errors[field] ||
                                                fieldDescription.regex_validator &&
                                                !(this.state.data[field] || '').match(
                                                    Radium.getState(this.state, field, ':focus')
                                                        ? fieldDescription.partial_regex_validator
                                                        : fieldDescription.regex_validator
                                                ) ||
                                                fieldDescription.min_length &&
                                                (this.state.data[field] || '').length < fieldDescription.min_length ||
                                                fieldDescription.max_length &&
                                                (this.state.data[field] || '').length > fieldDescription.max_length
                                            );
                                        const element = <input
                                            key={field}
                                            style={{
                                                ...styles.input,
                                                border: valid
                                                    ? styles.field.border
                                                    : `.0625em solid ${styles.alertColor}`,
                                                backgroundColor: valid
                                                    ? styles.input.backgroundColor
                                                    : styles.alertBackColor,
                                            }}
                                            value={(this.state.data[field] || '').persian()}
                                            onChange={({ target: { value } }) => {
                                                value = value.english();
                                                if (fieldDescription.partial_regex_validator) {
                                                    if (
                                                        value.length > 0 &&
                                                        !value.match(fieldDescription.partial_regex_validator)
                                                    )
                                                        return;
                                                }
                                                else {
                                                    if (isNaN(Number(value)) && value.length > 0)
                                                        return;
                                                    if (value.length > fieldDescription.max_length)
                                                        return;
                                                    if (Number.parseFloat(value) < 0)
                                                        return;
                                                    value = isNaN(Number.parseFloat(value)) ? '' : value;
                                                }
                                                this.setState(update(this.state, { data: { [field]: { $set: value } } }));
                                            }}
                                        />;
                                        return element;
                                    }
                                }
                                else if (fieldDescription.type === 'string' || fieldDescription.type === 'email') {
                                    if (readonly)
                                        return this.state.data[field] || '';
                                    else {
                                        const valid = (this.state.data[field] || '') === ''
                                            ? (this.state.mass || !fieldDescription.required || fieldDescription.write_only)
                                            : !(
                                                this.state.errors[field] ||
                                                fieldDescription.regex_validator &&
                                                !(this.state.data[field] || '').match(
                                                    Radium.getState(this.state, field, ':focus')
                                                        ? fieldDescription.partial_regex_validator
                                                        : fieldDescription.regex_validator
                                                ) ||
                                                fieldDescription.min_length &&
                                                (this.state.data[field] || '').length < fieldDescription.min_length ||
                                                fieldDescription.max_length &&
                                                (this.state.data[field] || '').length > fieldDescription.max_length
                                            );
                                        const element = <input
                                            key={field}
                                            style={{
                                                ...styles.input,
                                                border: valid
                                                    ? styles.field.border
                                                    : `.0625em solid ${styles.alertColor}`,
                                                backgroundColor: valid
                                                    ? styles.input.backgroundColor
                                                    : styles.alertBackColor,
                                            }}
                                            value={this.state.data[field] || ''}
                                            onChange={({ target: { value } }) => {
                                                if (fieldDescription.partial_regex_validator) {
                                                    if (
                                                        value.length > 0 &&
                                                        !value.match(fieldDescription.partial_regex_validator)
                                                    )
                                                        return;
                                                }
                                                else {
                                                    if (value.length > fieldDescription.max_length)
                                                        return;
                                                }
                                                this.setState(update(this.state, { data: { [field]: { $set: value } } }));
                                            }}
                                        />;
                                        return element;
                                    }
                                }
                                else if (fieldDescription.type === 'image') {
                                    return <span>
                                        <img
                                            style={{
                                                height: '50px',
                                                cursor: 'pointer',
                                                border: '.0625em solid black',
                                            }}
                                            src={this.state.data[field]
                                                ? _.isString(this.state.data[field])
                                                    ? imageUrl(this.state.data[field], { height: '50', type: 'contain' })
                                                    : this.state.data[field].data
                                                : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                                            }
                                            onClick={() => {
                                                this.refs.imageSelector.dataset.field = field;
                                                this.refs.imageSelector.click();
                                            }}
                                            onMouseDown={event => {
                                                if (event.button === 2)
                                                    this.setState(update(this.state, { data: { [field]: { $set: null } } }));
                                            }}
                                            onMouseEnter={async () => {
                                                this.refs['preview-' + field].style.display = '';
                                                await window.wait();
                                                this.refs['preview-' + field].style.opacity = '1';
                                            }}
                                        />
                                        <img
                                            ref={'preview-' + field}
                                            style={{
                                                height: '500px',
                                                cursor: 'pointer',
                                                opacity: '0',
                                                transition: 'opacity 500ms',
                                                backgroundColor: 'white',
                                                border: '.25em solid black',
                                                borderRadius: '3px',
                                                padding: '.5em',
                                                position: 'absolute',
                                                top: '%50',
                                                right: '0',
                                                transform: 'translateY(-50%)',
                                                display: 'none',
                                            }}
                                            src={this.state.data[field]
                                                ? _.isString(this.state.data[field])
                                                    ? imageUrl(this.state.data[field], { height: '500', type: 'contain' })
                                                    : this.state.data[field].data
                                                : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                                            }
                                            onClick={() => {
                                                this.refs.imageSelector.dataset.field = field;
                                                this.refs.imageSelector.click();
                                            }}
                                            onMouseDown={event => {
                                                if (event.button === 2)
                                                    this.setState(update(this.state, { data: { [field]: { $set: null } } }));
                                            }}
                                            onMouseLeave={() => {
                                                this.refs['preview-' + field].style.opacity = '0';
                                                setTimeout(() => this.refs['preview-' + field].style.display = 'none', 500);
                                            }}
                                        />
                                    </span>;
                                }
                                else if (fieldDescription.type === 'datetime') {
                                    if (readonly)
                                        return this.state.data[field] ? this.state.data[field].toJalali().persian() : '-';
                                    else
                                        return <DatePicker
                                            style={{
                                                ...styles.input,
                                                border: this.state.errors[field]
                                                    ? `.0625em solid ${styles.alertBorderColor}`
                                                    : styles.field.border,
                                            }}
                                            value={this.state.data[field]}
                                        />;
                                }
                                // select gender here 
                                else if (fieldDescription.type === 'choice') {
                                    return (
                                        <div style={styles.registerRightDialogField}>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                boxShadow: " rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
                                                fontSize: "0.95em",
                                                backgroundColor: "#fff",
                                                color: "black",
                                                padding: "12px",
                                                color:`${this.state.data.gender == 1 || this.state.data.gender == 2 ? "#000" : "rgba(0,0,0,0.6"}`,
                                                height: "unset",
                                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                                borderRadius: "3px"
                                            }}
                                            >
                                                <span style={{ width: "100%", height: "100%", display: "block" , cursor:"pointer" }} onClick={() => {
                                                    this.setState({ openGenderBox: !this.state.openGenderBox });
                                                }}>
                                                    {this.state.data.gender == 1 ? "مرد" : this.state.data.gender == 2 ? "زن" : "جنسیت"}
                                                </span>
                                                <span
                                                style={{cursor:"pointer",color:"rgba(100,100,100,0.7)" , fontSize:"1.2em"}}
                                                 onClick={() => {
                                                    this.setState({ openGenderBox: !this.state.openGenderBox });
                                                }}
                                                >
                                                    <i className="fa-chevron-down"></i>
                                                    </span>
                                            </div>
                                            <div style={{ position: "relative", zIndex: "100", height: "76px", display: `${this.state.openGenderBox ? "block" : "none"}`, backgroundColor: "#fff", border: "1px solid  rgba(0, 0, 0, 0.12)", borderTop: "none", borderRadius: "3px" }}>
                                                <div style={{ display: "flex", position: "absolute", top: "-3px", left: "0", width: "100%", flexDirection: "column", }}>
                                                    <div onClick={(e) => {
                                                        this.setState((prevState => ({ ...prevState, openGenderBox: false, data: { ...prevState.data, gender: 1 } })))
                                                    }} style={{ width: "100%", fontSize: "0.95em", color: "#000", padding: "0.25em 0.4em", boxSizing: "border-box", minHeight: "2.5em" , cursor:"pointer" }} value="1">
                                                        مرد
                                                    </div>
                                                    <div onClick={(e) => {
                                                        this.setState((prevState => ({ ...prevState, openGenderBox: false, data: { ...prevState.data, gender: 2 } })))
                                                    }} style={{ width: "100%", fontSize: "0.95em", color: "#000", padding: "0.25em 0.4em", boxSizing: "border-box", minHeight: "2.5em" ,cursor:"pointer" }} value="2">
                                                        زن
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )
                                }
                                else if (fieldDescription.resource) {
                                    if (fieldDescription.resource === 'subject')
                                        return [
                                            <Tree
                                                key={field + '-material'}
                                                store={this.props.store.getIn(['states', field + '-material'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='material'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel='title'
                                                label={window.gettext('Material')}
                                            />,
                                            <Tree
                                                key={field + '-subject'}
                                                store={this.props.store.getIn(['states', field + '-subject'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='subject'
                                                multiSelection={fieldDescription.multiple}
                                                tree
                                                combobox
                                                itemLabel={subject => `${subject.parent_material} - ${subject.title}`}
                                                filter={{
                                                    material: this.props.store.getIn(['states', field + '-material', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('Subject')}
                                            />,
                                        ];
                                    else if (fieldDescription.resource === 'grade') {
                                        if (this.props.resource !== 'marker' && this.props.resource !== 'manager') {
                                            return [
                                                <Tree
                                                    key={field + '-level'}
                                                    store={this.props.store.getIn(['states', field + '-level'])}
                                                    style={{
                                                        border: this.state.errors[field]
                                                            ? `.0625em solid ${styles.alertBorderColor}`
                                                            : styles.field.border,
                                                    }}
                                                    readonly
                                                    resource='level'
                                                    multiSelection={fieldDescription.multiple}
                                                    combobox
                                                    itemLabel='title'
                                                    label={window.pgettext('grade', 'Level')}
                                                />,
                                                <Tree
                                                    key={field + '-grade'}
                                                    store={this.props.store.getIn(['states', field + '-grade'])}
                                                    style={{
                                                        border: this.state.errors[field]
                                                            ? `.0625em solid ${styles.alertBorderColor}`
                                                            : styles.field.border,
                                                    }}
                                                    readonly
                                                    resource='grade'
                                                    multiSelection={fieldDescription.multiple}
                                                    combobox
                                                    itemLabel={grade => `${grade.level.title} - ${grade.title}`}
                                                    filter={{
                                                        level: this.props.store.getIn(['states', field + '-level', 'selected']).keySeq().join(',') || -1,
                                                    }}
                                                    label={window.gettext('Grade')}
                                                />,
                                            ];
                                        }
                                        else {
                                            return [];
                                        }
                                    }

                                    else if (fieldDescription.resource === 'question-type')
                                        return [
                                            <Tree
                                                key={field + '-material'}
                                                store={this.props.store.getIn(['states', field + '-material'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='material'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel='title'
                                                label={window.gettext('Material')}
                                            />,
                                            <Tree
                                                key={field + '-question-type'}
                                                store={this.props.store.getIn(['states', field + '-question-type'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='question-type'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={questionType => `${questionType.material.title} - ${questionType.title}`}
                                                filter={{
                                                    material: this.props.store.getIn(['states', field + '-material', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('Subject')}
                                            />,
                                        ];
                                    else if (fieldDescription.resource === 'class')
                                        return [
                                            <Tree
                                                key={field + '-region'}
                                                store={this.props.store.getIn(['states', field + '-region'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='region'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel='name'
                                                label={window.gettext('Region')}
                                            />,
                                            <Tree
                                                key={field + '-city'}
                                                store={this.props.store.getIn(['states', field + '-city'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='city'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={city => `${city.region_display} - ${city.name}`}
                                                filter={{
                                                    region: this.props.store.getIn(['states', field + '-region', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('City')}
                                            />,
                                            <Tree
                                                key={field + '-school'}
                                                store={this.props.store.getIn(['states', field + '-school'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='school'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={school => `${school.city.name} - ${school.name}`}
                                                filter={{
                                                    city: this.props.store.getIn(['states', field + '-city', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('School')}
                                            />,
                                            <Tree
                                                key={field + '-class'}
                                                store={this.props.store.getIn(['states', field + '-class'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='class'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={clazz => `${clazz.school.city.name} - ${clazz.school.name} - ${clazz.name}`
                                                }
                                                filter={{
                                                    school: this.props.store.getIn(['states', field + '-school', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('Class')}
                                            />,
                                        ];
                                    else if (fieldDescription.resource === 'school') {
                                        return [
                                            <Tree
                                                key={field + '-region'}
                                                store={this.props.store.getIn(['states', field + '-region'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='region'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel='name'
                                                label={window.gettext('Region')}
                                            />,
                                            <Tree
                                                key={field + '-city'}
                                                store={this.props.store.getIn(['states', field + '-city'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='city'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={city => `${city.region_display} - ${city.name}`}
                                                filter={{
                                                    region: this.props.store.getIn(['states', field + '-region', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('City')}
                                            />,
                                            <Tree
                                                key={field + '-school'}
                                                store={this.props.store.getIn(['states', field + '-school'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='school'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={school => `${school.city.name} - ${school.name}`}
                                                filter={{
                                                    city: this.props.store.getIn(['states', field + '-city', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('School')}
                                            />,
                                        ];
                                    }

                                    else if (fieldDescription.resource === 'city')
                                        return [

                                            <Tree
                                                key={field + '-region'}
                                                store={this.props.store.getIn(['states', field + '-region'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='region'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel='name'
                                                label={window.gettext('Region')}
                                            />,
                                            <Tree
                                                key={field + '-city'}
                                                store={this.props.store.getIn(['states', field + '-city'])}
                                                style={{
                                                    border: this.state.errors[field]
                                                        ? `.0625em solid ${styles.alertBorderColor}`
                                                        : styles.field.border,
                                                }}
                                                readonly
                                                resource='city'
                                                multiSelection={fieldDescription.multiple}
                                                combobox
                                                itemLabel={city => `${city.region_display} - ${city.name}`}
                                                filter={{
                                                    region: this.props.store.getIn(['states', field + '-region', 'selected']).keySeq().join(',') || -1,
                                                }}
                                                label={window.gettext('City')}
                                            />,
                                        ];
                                    else
                                        return <Tree
                                            store={this.props.store.getIn(['states', field])}
                                            style={{
                                                border: this.state.errors[field]
                                                    ? `.0625em solid ${styles.alertBorderColor}`
                                                    : styles.field.border,
                                            }}
                                            readonly
                                            resource={fieldDescription.resource}
                                            multiSelection={fieldDescription.multiple}
                                            combobox
                                            itemLabel={fieldDescription.item_label}
                                            label={window.gettext(fieldDescription.label)}
                                        />;
                                }
                            })()
                            }
                        </div>,
                        ...(_.includes(_.keys(this.props.hiddenDefaults), field)
                            ? []
                            : [
                                <hr key='hr' style={{
                                    borderTop: '.0625em solid #eaeaea', borderBottom: 'none',
                                    display: `${fieldDescription.type !== 'choice' ? "block" : ((this.props.resource === "school" || this.props.resource === "student" ? "block" : "none"))}`
                                }} />

                            ]
                        ),
                    ],
            )}
            {/* cancle btn */}
            <button
                style={{
                    ...styles.defaultButton,
                    backgroundColor: styles.fourthColor,
                    marginLeft: '.5em',
                    float: 'right',
                }}
                onClick={() => {
                    const path = this.context.store.getState().getIn(
                        ['routing', 'locationBeforeTransitions', 'pathname'],
                    );
                    if (this.props.close)
                        this.props.close();
                    else
                        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
                }}>
                {window.gettext('Cancel')}
            </button>
            {/* svae btn */}
            <button
                style={{
                    ...styles.defaultButton,
                    marginRight: '.5em',
                    float: 'left',
                    clear: 'left',
                }}
                onClick={async () => {
                    if (await this.save.bind(this)()) {
                        const path = this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        );
                        //path is student id
                        if (this.props.close)
                            this.props.close();
                        else
                        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
                        this.props.refresh();
                    }
                }}>
                {window.gettext('Save')}
            </button>
            {/* save and edit btn */}
            <button
                style={{
                    ...styles.button,
                    marginRight: '.5em',
                    float: 'left',
                    ...this.state.saved === true
                        ? {
                            backgroundColor: styles.successBackColor,
                        }
                        : this.state.saved === false
                            ? {
                                backgroundColor: styles.alertBackColor,
                            }
                            : {
                                backgroundColor: 'white',
                                transition: 'background-color 2500ms',
                            },
                }}
                onClick={this.save.bind(this)}>
                {window.gettext('Save and Continue Editing')}
            </button>
        </div>;
    }
}
